import { Theme } from '@infotech-soe/erp-ui-kit';
import { StylesheetJson } from 'cytoscape';
import { createUseStyles } from 'react-jss';

const MIN_HEIGHT = 560 as const;
const MIN_WIDTH = 800 as const;
const NODE_WIDTH = 270 as const;

export const useDialogStyles = createUseStyles({
  dialog: {
    minHeight: MIN_HEIGHT,
    minWidth: MIN_WIDTH,
    height: '80vh',
    width: '80vw',
  },
});

export const useGraphStyles = createUseStyles(({ colors }: Theme) => ({
  root: {
    backgroundColor: colors.backgroundGroup,
    borderRadius: 'var(--radiusBig)',
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(100% - 20px)',
    margin: 10,
    minHeight: MIN_HEIGHT - 100,
    position: 'relative',
    width: 'initial',
  },
  graph: {
    backgroundColor: 'transparent',
    flexGrow: 2,
    overflow: 'hidden',
  },
}));

export const getCytoscapeStyles = ({
  colors,
  global: { body },
}: Theme): StylesheetJson => [
  // http://js.cytoscape.org/#selectors/state
  {
    selector: 'edge',
    css: {
      'curve-style': 'bezier',
      events: 'no',
      'line-color': colors.icon,
      'target-arrow-color': colors.icon,
      'target-arrow-shape': 'triangle',
      width: 1,
    },
  },
  {
    selector: 'node',
    css: {
      'background-color': colors.backgroundGridPrimary,
      'border-color': colors.icon,
      'border-width': 1,
      'overlay-opacity': 0,
      'overlay-padding': 0,
      padding: '1px',
      shape: 'round-rectangle',
      color: colors.typoCommon,
      'font-family': body.fontFamily,
      'font-size': body.fontSize,
      'text-valign': 'center',
      'text-wrap': 'ellipsis',
      'text-max-width': `${NODE_WIDTH}px`,
      width: NODE_WIDTH,
    },
  },
  {
    selector: 'node[label]',
    css: {
      label: 'data(label)',
    },
  },
  {
    selector:
      '[type = "headerNode"], [type = "documentNode"], [type = "summaryNode"]',
    css: {
      'background-opacity': 0,
      'border-color': colors.borderGroup,
      events: 'no',
      'padding-left': '5px',
      'padding-right': '5px',
    },
  },
  {
    selector: '[type = "headerNode"]',
    css: {
      'border-width': 0,
      'font-weight': 'bold',
    },
  },
  {
    selector: '[type = "categoryNode"]:active',
    css: {
      'background-color': colors.secondaryHover,
      'border-style': 'dotted',
      'border-width': 2,
    },
  },
  {
    selector: '[type = "categoryNode"]:active > node',
    css: {
      'border-color': colors.borderActiveCell,
      'border-opacity': 0.5,
      color: colors.typoSecondary,
    },
  },
  {
    selector: '[type = "categoryNode"]:selected',
    css: {
      'background-color': colors.secondary,
    },
  },
  {
    selector: '[type = "categoryNode"]:selected > node',
    css: {
      'border-color': colors.borderControlHover,
      'border-opacity': 0.5,
      color: colors.typoSecondary,
    },
  },
  {
    selector: '[type = "categoryNode"].source',
    css: {
      'background-color': colors.primary,
    },
  },
  {
    selector: '[type = "categoryNode"].source > node',
    css: {
      'border-color': colors.borderActiveCell,
      'border-opacity': 0.5,
      color: colors.typoPrimary,
    },
  },
  {
    selector: '[type = "categoryNode"].source:selected',
    css: {
      'background-color': colors.primaryHover,
    },
  },
  {
    selector: '[type = "categoryNode"].source:selected > node',
    css: {
      color: colors.typoPrimary,
    },
  },
];
